// extracted by mini-css-extract-plugin
export var primaryBody = "Primary-module--primaryBody--a7bb9";
export var primaryButton = "Primary-module--primaryButton--fa511";
export var primaryHeading = "Primary-module--primaryHeading--4dff3";
export var primarySubheading = "Primary-module--primarySubheading--c1b7d";